// import { Component } from '@angular/core';
// import { Router } from '@angular/router';
// // import { HttpClient } from '@angular/common/http';
// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.scss']
// })
// export class AppComponent {
//   // title = 'm2m';
//   constructor(public router: Router,
//     // private http: HttpClient
//   ) { }
// }

// //

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  private channel = new BroadcastChannel('app_tab_channel');
  isDuplicateTab = false;
  private tabId = Date.now().toString();
  private heartbeatInterval: any;

  constructor(public router: Router) { }

  ngOnInit(): void {
    // Ask all existing tabs if any are active
    this.channel.postMessage({ type: 'CHECK_TAB', tabId: this.tabId });

    // Listen for responses
    this.channel.onmessage = (msg) => {
      if (msg.data.type === 'TAB_ACTIVE' && msg.data.tabId !== this.tabId) {
        // Another tab responded as active — this tab is duplicate
        this.isDuplicateTab = true;
        this.channel.close();
      }

      if (msg.data.type === 'CHECK_TAB' && !this.isDuplicateTab) {
        // Someone is checking — respond that this tab is active
        this.channel.postMessage({ type: 'TAB_ACTIVE', tabId: this.tabId });
      }
    };
  }

  ngOnDestroy(): void {
    this.channel.close();
  }
}
